import React from "react"
import { Field, propTypes, reduxForm } from "redux-form"
import { defineMessages } from "react-intl"
import FormGroup from "@material-ui/core/FormGroup"
import Box from "@material-ui/core/Box"
import Typography from "@material-ui/core/Typography"
import { MenuItem } from "@material-ui/core"
import _ from "lodash"
import SearchIcon from "@material-ui/icons/Search"
import FieldDatePicker from "../../component/forms/FieldDatePicker"
import { ButtonClear, ButtonSubmit } from "../../component/buttons"
import useSmartFormat from "../../i18n/useSmartFormat"
import SelectInput from "../../component/forms/SelectInput"
import FieldTextarea from "../../component/forms/FieldTextarea"
import { words } from "../../i18n/lstrings"

export const DocumentFormsSearchFormName = "DocumentFormsSearchForm"

const messages = defineMessages({
  search: {
    id: "word.search",
    defaultMessage: "Search"
  },
  withAction: {
    id: "document.search.criteria.actions",
    defaultMessage: "Waiting for action"
  },
  forms: {
    id: "word.forms",
    defaultMessage: "Forms"
  },
  documents: {
    id: "word.documents",
    defaultMessage: "Documents"
  },
  toSignForm: {
    id: "document.search.forms.to.sign",
    defaultMessage: "Forms to fill"
  },
  from: {
    id: "word.from",
    defaultMessage: "From"
  },
  to: {
    id: "word.to",
    defaultMessage: "To"
  }
})

/**
 * This component is used to render the Advanced Search Popper inside the Forms tab of the Documents Page
 * */
function DocumentFormsSearchForm({
  handleSubmit,
  pristine,
  submitting,
  invalid,
  reset,
  onSubmit
}) {
  const format = useSmartFormat()

  const withAction = [
    {
      id: "empty",
      value: "",
      text: "None"
    },
    {
      id: "form_to_sign",
      value: "form_to_sign",
      text: format(messages.toSignForm)
    }
  ]
  const formsType = [
    {
      id: "simple",
      value: "simple",
      text: format(words.simple)
    },
    {
      id: "periodic",
      value: "periodic",
      text: format(words.periodic)
    },
    {
      id: "persistent",
      value: "persistent",
      text: format(words.persistent)
    }
  ]

  const getMenuItem = (item) => (
    <MenuItem key={item.id} value={item.value}>
      {(_.isEmpty(item.value) && <em>{item.text}</em>) || item.text}
    </MenuItem>
  )

  return (
    <Box p={2} w="400">
      <Typography gutterBottom variant="h6">
        {format(messages.search)}
      </Typography>
      <form onSubmit={handleSubmit(onSubmit)}>
        <FormGroup>
          <Box display="flex" gridGap={8}>
            <Field
              component={FieldDatePicker}
              id="from"
              placeholder={format(messages.from)}
              name="fromDate"
            />
            <Field
              component={FieldDatePicker}
              id="to"
              name="toDate"
              placeholder={format(messages.to)}
            />
          </Box>

          <Field
            component={SelectInput}
            label={format(messages.withAction)}
            name="needAction"
          >
            {withAction.map((item) => getMenuItem(item))}
          </Field>

          <Field component={SelectInput} label={format(words.type)} name="type">
            {formsType.map((item) => getMenuItem(item))}
          </Field>
          <Field
            component={FieldTextarea}
            label={format(words.name)}
            name="namePattern"
            placeholder={format(words.name)}
            type="text"
          />
        </FormGroup>
        <Box mt={2} gridGap={8} display="flex" justifyContent="flex-end">
          <ButtonClear disabled={pristine || submitting} onClick={reset} />
          <ButtonSubmit
            startIcon={<SearchIcon />}
            disabled={invalid || submitting}
            text={words.search}
          />
        </Box>
      </form>
    </Box>
  )
}

// TODO : implementer une validation
function validate(/* values */) {
  return {}
}

DocumentFormsSearchForm.propTypes = {
  ...propTypes
}

export default reduxForm({
  form: DocumentFormsSearchFormName,
  destroyOnUnmount: false,
  validate
})(DocumentFormsSearchForm)
